"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const link_1 = require("./link");
const shortcut_1 = __importDefault(require("@atlaskit/icon/glyph/shortcut"));
const utilities_1 = require("../utilities");
const { AkNavigationItem } = require("@atlaskit/navigation");
class RouterLinkComponent extends React.Component {
    render() {
        const { href, children, onClick, className } = this.props;
        return (React.createElement(link_1.Link, { className: className, onClick: onClick, to: href }, children));
    }
}
// Comparing only path, without parameters
const samePaths = (a, b) => a.replace(/\?.+/, "") == b.replace(/\?.+/, "");
class NavigationItemView extends React.Component {
    constructor() {
        super(...arguments);
        this.onClick = (...args) => {
            if (this.props.text) {
                track("NavigationItem: Click", {
                    category: "info",
                    label: this.props.text
                });
            }
            if (this.props.onClick) {
                this.props.onClick(...args);
            }
        };
    }
    render() {
        const { href, text, location } = this.props;
        return (React.createElement(AkNavigationItem, Object.assign({ isSelected: href ? samePaths(href, location.pathname) : false, isCompact: true, linkComponent: href ? RouterLinkComponent : undefined }, this.props, { onClick: this.onClick, text: href && link_1.isExternalUrl(href) ? (React.createElement("span", null,
                text || "",
                " ",
                React.createElement(shortcut_1.default, { size: "small", label: text || "ShortcutIcon" }))) : (text) })));
    }
}
exports.NavigationItemView = NavigationItemView;
exports.NavigationItem = utilities_1.compose(react_router_dom_1.withRouter)(NavigationItemView);
